import { render } from "./ValidationFieldSet.vue?vue&type=template&id=490e66f8&scoped=true&ts=true"
import script from "./ValidationFieldSet.vue?vue&type=script&lang=ts"
export * from "./ValidationFieldSet.vue?vue&type=script&lang=ts"

import "./ValidationFieldSet.vue?vue&type=style&index=0&id=490e66f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490e66f8"]])

export default __exports__